<template>
    <modal v-if="showModal" @close="close" size="auth">
        <template v-slot:header>
            &nbsp;
        </template>
        <template slot="body">
            <auth-component @success="close"></auth-component>
        </template>
    </modal>

</template>

<script>
import Modal from "@/components/parts/modal";
import Auth from "@/components/auth/Auth";
import Vuex from "vuex";

export default {
    name: "AuthModal",
    components: {
        Modal,
        'auth-component': Auth
    },
    computed:{
        ...Vuex.mapGetters({
            userLoggedIn: 'getUserStatus'
        }),
        showModal(){

            return !this.userLoggedIn && this.$store.state.loginModal;
        }
    },
    methods:{
        close(){
            this.$store.commit('hideLoginModal');
        }
    }

}
</script>

<style scoped>

</style>
